export default __webpack_public_path__ + "static/media/fastingvacation@2x.e8659fa9.jpg";